import React from "react";
import { Switch } from "react-router-dom";

import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";

import ConsoleComponent from "../containers/console";
import SignInComponent from "../containers/signIn";
import SignUpComponent from "../containers/signUp";
import ViewOffer from "../containers/viewOffer";
import VerifyMobile from "../containers/verifyMobile";
import forgetPassword from "../containers/forgetPassword";
import AboutUs from "../containers/modal/MoreInfo/AboutUs";
import FAQ from "../containers/modal/MoreInfo/FAQ";
import ContactUs from "../containers/modal/MoreInfo/ContactUs";
import Careers from "../containers/modal/MoreInfo/Careers";
import errorPage from "../containers/errorPage";
import ViewBank from "../containers/viewBank";

const Index = (props) => (
  <Switch>
    <PublicRoute component={SignInComponent} path="/sign-in" />
    <PublicRoute component={SignUpComponent} path="/sign-up" />
    <PublicRoute component={forgetPassword} path="/forget-password" />
    <PublicRoute component={VerifyMobile} path="/verify-mobileNo" />
    <PublicRoute component={ViewOffer} path="/:bank/:category/:offerId" exact />
    <PublicRoute
      component={ViewBank}
      path="/credit-card-offers/:bank/:bankId/:category/:categoryId"
      exact
    />
    <PublicRoute component={AboutUs} path="/about-us" />
    <PublicRoute component={FAQ} path="/faq" />
    <PublicRoute component={ContactUs} path="/contact-us" />
    <PublicRoute component={Careers} path="/careers" />
    {/* <PublicRoute component={errorPage} path="/errorPage" /> */}

    <PublicRoute component={ConsoleComponent} path="/" exact />
    {/* <PublicRoute component={ConsoleComponent} path="/:module" exact /> */}
    {/* <PrivateRoute component={ConsoleComponent} path="/:module/:module" exact />

    <PrivateRoute
      component={ConsoleComponent}
      path="/:module/:module/:module"
      exact
    />
    <PrivateRoute
      component={ConsoleComponent}
      path="/:module/:module/:module/:module"
      exact
    /> */}
    <PublicRoute component={errorPage} />
  </Switch>
);

export default Index;
